/**
 * @flow
 * @relayHash 3d463f5ea0013dc8248a2e51e74edc24
 */

/* eslint-disable */

"use strict";

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type WeekTimetableStatus = "ACC" | "DEN" | "DR" | "PE" | "%future added value";
export type TimetableSubscriptionVariables = {||};
export type TimetableSubscriptionResponse = {|
  +timetableSubscription: ?{|
    +action: ?string,
    +dayPresencesIncidentalOld: ?string,
    +timetable: ?{|
      +id: string,
      +pk: ?number,
      +year: number,
      +weekOfYear: number,
      +status: WeekTimetableStatus,
      +dayPresences: any,
      +dayPresencesIncidental: ?any,
      +employee: {|
        +id: string,
        +pk: ?number,
        +displayName: ?string,
      |},
    |},
  |}
|};
export type TimetableSubscription = {|
  variables: TimetableSubscriptionVariables,
  response: TimetableSubscriptionResponse,
|};
*/

/*
subscription TimetableSubscription {
  timetableSubscription {
    action
    dayPresencesIncidentalOld
    timetable {
      id
      pk
      year
      weekOfYear
      status
      dayPresences
      dayPresencesIncidental
      employee {
        id
        pk
        displayName
      }
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function () {
  var v0 = {
      kind: "ScalarField",
      alias: null,
      name: "id",
      args: null,
      storageKey: null,
    },
    v1 = {
      kind: "ScalarField",
      alias: null,
      name: "pk",
      args: null,
      storageKey: null,
    },
    v2 = [
      {
        kind: "LinkedField",
        alias: null,
        name: "timetableSubscription",
        storageKey: null,
        args: null,
        concreteType: "TimetableSubscription",
        plural: false,
        selections: [
          {
            kind: "ScalarField",
            alias: null,
            name: "action",
            args: null,
            storageKey: null,
          },
          {
            kind: "ScalarField",
            alias: null,
            name: "dayPresencesIncidentalOld",
            args: null,
            storageKey: null,
          },
          {
            kind: "LinkedField",
            alias: null,
            name: "timetable",
            storageKey: null,
            args: null,
            concreteType: "TimetableType",
            plural: false,
            selections: [
              v0,
              v1,
              {
                kind: "ScalarField",
                alias: null,
                name: "year",
                args: null,
                storageKey: null,
              },
              {
                kind: "ScalarField",
                alias: null,
                name: "weekOfYear",
                args: null,
                storageKey: null,
              },
              {
                kind: "ScalarField",
                alias: null,
                name: "status",
                args: null,
                storageKey: null,
              },
              {
                kind: "ScalarField",
                alias: null,
                name: "dayPresences",
                args: null,
                storageKey: null,
              },
              {
                kind: "ScalarField",
                alias: null,
                name: "dayPresencesIncidental",
                args: null,
                storageKey: null,
              },
              {
                kind: "LinkedField",
                alias: null,
                name: "employee",
                storageKey: null,
                args: null,
                concreteType: "UserType",
                plural: false,
                selections: [
                  v0,
                  v1,
                  {
                    kind: "ScalarField",
                    alias: null,
                    name: "displayName",
                    args: null,
                    storageKey: null,
                  },
                ],
              },
            ],
          },
        ],
      },
    ];
  return {
    kind: "Request",
    operationKind: "subscription",
    name: "TimetableSubscription",
    id: null,
    text:
      "subscription TimetableSubscription {\n  timetableSubscription {\n    action\n    dayPresencesIncidentalOld\n    timetable {\n      id\n      pk\n      year\n      weekOfYear\n      status\n      dayPresences\n      dayPresencesIncidental\n      employee {\n        id\n        pk\n        displayName\n      }\n    }\n  }\n}\n",
    metadata: {},
    fragment: {
      kind: "Fragment",
      name: "TimetableSubscription",
      type: "Subscription",
      metadata: null,
      argumentDefinitions: [],
      selections: v2,
    },
    operation: {
      kind: "Operation",
      name: "TimetableSubscription",
      argumentDefinitions: [],
      selections: v2,
    },
  };
})();
// prettier-ignore
(node/*: any*/).hash = 'df0628eee3eabc8dd500ff780aad8033';
module.exports = node;



// WEBPACK FOOTER //
// ./src/subscriptions/__generated__/TimetableSubscription.graphql.js